import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Header.css";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [activeItem, setActiveItem] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Set active item based on current route
  useEffect(() => {
    const currentPath = location.pathname;
    const activeIndex = navItems.findIndex((item) => item.path === currentPath);
    setActiveItem(activeIndex >= 0 ? activeIndex : 0);
  }, [location.pathname]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleContactClick = (e) => {
    e.preventDefault();
    setIsMenuOpen(false);
    // İletişim sayfasına yönlendir
    navigate("/iletisim");
  };

  const navItems = [
    { path: "/", label: "Ana Sayfa" },
    { path: "/hizmetler", label: "Hizmetler" },
    { path: "/urunler", label: "Ürünler" },
    { path: "/hakkimizda", label: "Hakkımızda" },
    { path: "/kurumsal", label: "Kurumsal" },
  ];

  return (
    <header className={`header ${isScrolled ? "scrolled" : ""}`}>
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <img
              src="/images/logo.png"
              alt="RPM Kompresör"
              className="logo-image"
            />
          </Link>

          <nav className={`nav ${isMenuOpen ? "nav-open" : ""}`}>
            <div className="nav-links-container">
              {navItems.map((item, index) => (
                <div
                  key={item.path}
                  className={`nav-item-wrapper ${
                    hoveredItem === index ? "hovered" : ""
                  } ${activeItem === index ? "active" : ""}`}
                >
                  <Link
                    to={item.path}
                    className={`nav-link ${
                      isActive(item.path) ? "active" : ""
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                    onMouseEnter={() => setHoveredItem(index)}
                    onMouseLeave={() => setHoveredItem(null)}
                  >
                    {item.label}
                  </Link>
                </div>
              ))}
            </div>
            <button onClick={handleContactClick} className="btn ">
              İletişim
            </button>
          </nav>

          <button
            className={`menu-toggle ${isMenuOpen ? "active" : ""}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
